import examApi from "../api/examApi"

export function getExamAction(query = {q: '', offset: 0, page: 1}) {
    return function(dispatch) {
      return examApi.getExam(query).then(response => {
        dispatch(getExamSuccess(response.data))
      }).catch(error => {
        dispatch(getExamFail(error.response.data))
      })
    }
}

function getExamSuccess(response) {
  return { type: 'GET_EXAM_SUCCESS', response }
}

function getExamFail(response) {
  return { type: 'GET_EXAM_ERROR', response }
}

export function getPdfAction(report_id) {
    return function(dispatch) {
      dispatch(getPdfStart())
      return examApi.getPdf(report_id).then(response => {

      const file = new Blob(
        [response.data],
        {type: 'application/pdf'});

        const fileURL = URL.createObjectURL(file);

        window.open(fileURL);
        dispatch(getPdfSuccess())
        
      }).catch(error => {
        dispatch(getPdfFail())
      })
    }
}

function getPdfStart() {
  return { type: 'GET_PDF_START' }
}

function getPdfSuccess() {
  return { type: 'GET_PDF_SUCCESS' }
}

function getPdfFail() {
  return { type: 'GET_PDF_FAIL' }
}